document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('international-order-popup');
  const continueButton = document.getElementById('international-popup-continue');
  const cancelButton = document.getElementById('international-popup-cancel');

  if (!popup || !continueButton || !cancelButton) return;

  let pendingForm = null;
  let checkoutApproved = false;

  // Get the customer's selected Shopify country
  const country =
    document.getElementById('cart-notification-form')?.dataset.customerCountry ||
    document.documentElement.dataset.customerCountry;

  // Intercept checkout from both cart locations
  document.addEventListener('submit', function (event) {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;

    const isNotificationCheckout =
      form.id === 'cart-notification-form';

    const isCartPageCheckout =
      form.id === 'cart';

    if (!isNotificationCheckout && !isCartPageCheckout) return;

    if (event.submitter?.name !== 'checkout') return;

    const selectedCountry = form.dataset.customerCountry || country;

    if (
      checkoutApproved ||
      !selectedCountry ||
      selectedCountry.toUpperCase() === 'GB'
    ) {
      return;
    }

    event.preventDefault();

    pendingForm = form;
    popup.hidden = false;
  }, true);

  // Continue to checkout after acknowledgement
  continueButton.addEventListener('click', function () {
    popup.hidden = true;

    if (pendingForm) {
      const form = pendingForm;
      pendingForm = null;
      checkoutApproved = true;

      const checkoutButton = form.querySelector('[name="checkout"]');

      if (checkoutButton) {
  HTMLFormElement.prototype.requestSubmit.call(form, checkoutButton);
} else {
  window.location.href = '/checkout';
}
    }
  });

  // Close popup without checking out
  cancelButton.addEventListener('click', function () {
    popup.hidden = true;
    pendingForm = null;
  });
});